// google-map.provider.jsx
import { useJsApiLoader } from "@react-google-maps/api";
import { PageLoader } from "../components/loaders/pageloader.component";

const GOOGLE_LIBRARIES = ["places"];

export const GoogleMapsProvider = ({ children }) => {
    const { isLoaded, loadError } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: GOOGLE_LIBRARIES,
    });

    if (loadError) return <div>Failed to load Google Maps</div>;
    if (!isLoaded) return <PageLoader />;

    return children;
};
